import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { addBlockKeyword } from "../../../config/LiveApi";

const AddNewKeyword = ({ onClose }) => {
  const token = useSelector((store) => store.userReducer.token);
  const [keyword, setKeyword] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!keyword.trim()) {
      toast.error("Keyword is required.");
      return;
    }

    try {
      setLoading(true);
      await addBlockKeyword(keyword);
      toast.success("Keyword added successfully.");
      onClose();
      window.location.reload();
    } catch (error) {
      console.error("Error adding Keyword:", error);
      toast.error(error?.response?.data?.message || "Failed to add Keyword.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="ips-modal-overlay">
      <div className="ips-modal-content">
        <button onClick={onClose} className="ips-modal-buttons-close">
          <FaTimes size={25} />
        </button>
        <h2>Add New Keyword</h2>
        <form onSubmit={handleSubmit}>
          <label htmlFor="keyword">Enter Keyword:</label>
          <input
            type="text"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="Enter new keyword"
          />
          <button className="ips-modal-buttons" type="submit" disabled={loading}>
            {loading ? "Adding..." : "Add Keyword"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddNewKeyword;
